<template>
  <div class="leaderboardLong" id="leaderboardLong">
    <div class="title">Leaderboard (Long Montages)</div>
    <ul class="tabList">
      <li :class="{ active: activeTabLong === 0 }" @click="setActiveTabLong(0)"><b></b>Form</li>
      <li :class="{ active: activeTabLong === 1 }" @click="setActiveTabLong(1)"><b></b>Chart</li>
    </ul>
    <div class="board_tabs_Long">
      <div class="item" v-if="activeTabLong === 0">
        <div class="table_wrapper">
          <el-table
            class="Leaderboard_table"
            :data="tableDataLong"
            :default-sort="{ prop: 'Avg', order: 'descending' }"
            style="width: 100%"
            max-height="500"
            @sort-change="handleSortChange"
          >
            <el-table-column label="" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="methods" :render-header="renderHeader('Methods')" width="160"></el-table-column>
            <el-table-column label="Long Object Needle Grounding">
              <el-table-column prop="objRecall07" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.7')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column prop="objRecall05" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.5')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column
                prop="objmAP"
                sortable
                :render-header="renderHeader('Average<br>&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
                width="140"
              ></el-table-column>
            </el-table-column>
            <el-table-column label="Long Scene Needle Grounding">
              <el-table-column prop="sceneRecall07" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.7')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column prop="sceneRecall05" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.5')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column
                prop="scenemAP"
                sortable
                :render-header="renderHeader('Average<br>&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
                width="140"
              ></el-table-column>
            </el-table-column>
            <el-table-column prop="Avg" sortable :render-header="renderHeader('Avg Recall@1x,<br>tIoU=0.7')" width="190" :formatter="formatNumber"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="item" v-if="activeTabLong === 1">
        <LineChartLong></LineChartLong>
      </div>
    </div>
  </div>
</template>

<script>
import LineChartLong from "./LineChartLong.vue";
export default {
  name: "LeaderboardLong",
  components: { LineChartLong },
  data() {
    return {
      activeTabLong: 0,
      tableDataLong: [
        {
          methods: "Qwen-VL-Max",
          objRecall07: 0.94,
          objRecall05: 1.88,
          objmAP: 4.83,
          sceneRecall07: 0.95,
          sceneRecall05: 3.32,
          scenemAP: 7.12,
          Avg: 0.95,
        },
        {
          methods: "GPT-4o",
          objRecall07: 2.83,
          objRecall05: 7.29,
          objmAP: 23.2,
          sceneRecall07: 2.9,
          sceneRecall05: 7.88,
          scenemAP: 26.74,
          Avg: 2.87,
        },
        {
          methods: "Gemini-1.5-Flash-8B",
          objRecall07: 25.53,
          objRecall05: 34.04,
          objmAP: 47.63,
          sceneRecall07: 39.3,
          sceneRecall05: 44.54,
          scenemAP: 60.97,
          Avg: 32.42,
        },
        {
          methods: "Gemini-1.5-Flash-002",
          objRecall07: 40.43,
          objRecall05: 51.49,
          objmAP: 66.0,
          sceneRecall07: 54.15,
          sceneRecall05: 65.5,
          scenemAP: 75.49,
          Avg: 47.29,
        },
        {
          methods: "Gemini-1.5-Pro-002",
          objRecall07: 51.91,
          objRecall05: 60.85,
          objmAP: 73.45,
          sceneRecall07: 67.69,
          sceneRecall05: 72.05,
          scenemAP: 82.18,
          Avg: 59.8,
        },
        {
          methods: "Human Experts",
          objRecall07: 81.33,
          objRecall05: 85.33,
          objmAP: 90.67,
          sceneRecall07: 82.61,
          sceneRecall05: 85.51,
          scenemAP: 91.16,
          Avg: 81.97,
        },
      ],
    };
  },
  methods: {
    setActiveTabLong(index) {
      this.activeTabLong = index;
    },
    renderHeader(label) {
      return (h) => {
        return h("span", {
          domProps: {
            innerHTML: label,
          },
        });
      };
    },
    handleSortChange({ prop, order }) {
      if (order === "ascending") {
        this.tableDataLong.sort((a, b) => this.sortData(a, b, prop));
      } else if (order === "descending") {
        this.tableDataLong.sort((a, b) => this.sortData(b, a, prop));
      }
    },
    sortData(a, b, prop) {
      if (typeof a[prop] === "string" && typeof b[prop] === "string") {
        return a[prop].localeCompare(b[prop]);
      }
      return a[prop] - b[prop];
    },
    formatNumber(row, column, cellValue) {
      const value = parseFloat(cellValue || 0);
      return value.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
$tablet: 1024px; // 平板及以下（≤1024px）
$mobile: 768px; // 移动端及以下（≤768px）
.leaderboardLong {
  margin: 40px auto 0px;
  width: 100%;
  position: relative;
  padding: 0 15px;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    position: relative;
    z-index: 1;
  }

  .tabList {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      width: 80px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #d0d0d0;
      text-align: left;
      font-style: normal;
      border: 1px solid rgba(208, 208, 208, 1);
      cursor: pointer;
      list-style: none;

      &:nth-child(1) {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-right-color: transparent;

        b {
          background: url("../../assets/images/fill_1.png") no-repeat;
          background-size: 100% 100%;
          width: 14px;
          height: 13px;
          margin-right: 5px;
        }
      }

      &:nth-child(2) {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        border-left-color: transparent;

        b {
          background: url("../../assets/images/fill_4.png") no-repeat;
          background-size: 100% 100%;
          width: 14px;
          height: 13px;
          margin-right: 5px;
        }
      }

      &.active {
        color: rgba(255, 98, 31, 1);
        border: 1px solid rgba(255, 98, 31, 1);

        &:nth-child(1) {
          b {
            background: url("../../assets/images/fill_2.png") no-repeat;
          }
        }

        &:nth-child(2) {
          b {
            background: url("../../assets/images/fill_3.png") no-repeat;
          }
        }
      }
    }
  }

  .board_tabs_Short {
    width: 100%;

    .item {
      width: 100%;
      height: auto;
      overflow: auto !important;
    }
  }

  .table_wrapper {
    overflow-x: auto;
  }
}

// 平板适配（≤1024px）
@media (max-width: $tablet) {
  .leaderboardLong {
    .title {
      font-size: 36px;
      margin-bottom: 25px;
    }

    .tabList li {
      width: 75px;
      font-size: 13px;
    }

    .chart_wrapper {
      height: 400px; // 缩小图表高度
    }

    // 表格字体缩小，节省空间
    ::v-deep .el-table {
      font-size: 12px;

      .el-table__header-wrapper .cell {
        font-size: 11px;
        height: 45px; // 增加表头高度，避免文字重叠
      }

      .el-table__body-wrapper .el-table__cell {
        padding: 10px 0; // 减少单元格内边距
      }
    }
  }
}

// 移动端适配（≤768px）
@media (max-width: $mobile) {
  .leaderboardLong {
    .title {
      font-size: 26px;
      margin-bottom: 20px;
    }

    .tabList {
      margin-bottom: 15px;
    }

    .board_tabs_Short .item {
    }
  }
}

// 表格样式穿透
::v-deep {
  .el-table.Leaderboard_table {
    background-color: transparent;
    border-collapse: collapse;
    border: none !important;

    th.el-table__cell,
    td.el-table__cell {
      border: none !important;
    }

    .el-table__header-wrapper {
      .el-table__header {
        thead {
          color: #e2e2e2;

          tr {
            background: transparent;

            &:first-child {
              th.el-table__cell.is-leaf {
                vertical-align: bottom;
              }
            }
          }
        }
      }

      th.el-table__cell.is-leaf {
        border-bottom: 1px solid transparent;
      }

      th.el-table__cell {
        background-color: transparent;
        padding: 0px;

        .cell {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          font-size: 12px;

          .caret-wrapper {
            margin-left: 5px;
          }
        }
      }

      .descending .sort-caret.descending {
        border-top-color: rgb(255, 98, 31);
      }

      .ascending .sort-caret.ascending {
        border-bottom-color: rgb(255, 98, 31);
      }
    }

    .el-table__body-wrapper {
      .el-table__body {
        color: #e0e0e0;
        font-size: 12px;

        tr:nth-child(1) {
          color: #ff401f;
        }

        tr:nth-child(2) {
          color: #ff8653;
        }

        tr:nth-child(3) {
          color: #ffdc3c;
        }

        tr:nth-child(odd) {
          background: rgba(216, 216, 216, 0.1);
          border-radius: 16px 0px 0px 16px;

          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }

        tr:nth-child(even) {
          background: transparent;
          border-radius: 16px 0px 0px 16px;

          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }

        tr:hover > td.el-table__cell {
          background: rgba(216, 216, 216, 0.2);
          border-bottom: none !important;
        }

        .el-table__cell {
          padding: 12px 0;
          border-bottom: 1px solid transparent;
        }

        tr > .el-table__cell:nth-child(n + 3) {
          text-align: center !important;
        }
      }
    }

    .el-table--border::after,
    .el-table--group::after,
    &::before {
      background: transparent;
    }

    &::before,
    &::after {
      display: none !important;
    }
    // 滚动条样式
    .el-table__body-wrapper::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: rgba(216, 216, 216, 0.4);
      border-radius: 3px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}
</style>
